// extracted by css-extract-rspack-plugin
export default {"emptyFieldValue":"index-module__emptyFieldValue__lVBdd","linkedPullRequestContainer":"index-module__linkedPullRequestContainer__ECtYS"};